import { getBrandLogo } from './get-logo';

export {
  getBrandLogo,
};
